<template>
    <div class="page-content">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <div class="wrap-form">
            <div>
                <select v-model="selected_ua" v-bind:key="selected_ua">
                    <option v-for="ua in uas" v-bind:key="ua.id" v-bind:value="ua.id">{{ ua.type + ' | ' + ua.group + ' | ' + ua.UA}}</option>
                </select>
            </div>
            <div class="safe-txtarea">
                <textarea wrap="off" rows="10" cols="230" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="off" v-model="text" name="text-tools" v-bind:readonly="working > 0" v-bind:class="{'working':(working > 0)}"></textarea>
            </div>
            <div>
                <button v-on:click="addNew">Check URLS</button>
                <div class="textarea-accessory">
                    <span>{{lines}} lines / {{filteredResults.length}} results shown</span>
                    <button><file-text-icon></file-text-icon></button>
                    <button class="green" v-on:click="''"><file-plus-icon></file-plus-icon></button>
                    <button class="red" v-on:click="''"><file-minus-icon></file-minus-icon></button>
                </div>
            </div>
        </div>
        <div id="results">
            <div class="searchbox">
                <p class="first">
                    <a class="refresh" href="#" v-on:click="''"><refresh-cw-icon></refresh-cw-icon></a><search-input v-model="search_string"></search-input>
                </p>
                <p class="filter">
                    Show:
                    [<span v-if="filterMode === 'all'">all</span><a v-else href="#" v-on:click="filterMode = 'all'">all</a>],
                    [<span v-if="filterMode === 'lovesus'"><span class="loves" title="links to us">&#9829;</span>&<span class="redirects" title="redirects to us">&#9733;</span></span><a v-else href="#" v-on:click="filterMode = 'lovesus'">&#9829;&&#9733;</a>],
                    [<span v-if="filterMode === 'errors'"><span class="errors">&#9888;</span> errors</span><a v-else href="#" v-on:click="filterMode = 'errors'">&#9888; errors</a>],
                    [<span v-if="filterMode === 'redirects'">&#9735; redirects</span><a v-else href="#" v-on:click="filterMode = 'redirects'">&#9735; redirects</a>]
                </p>
            </div>
            <u-r-l-result v-for="(result, index) in filteredResults" v-bind:result="result" v-bind:key="result.id" v-bind:order="(((index % 2) === 0)?'even':'odd')"></u-r-l-result>
            <div v-show="working > 0" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import qs from 'qs'
    import Storages from 'js-storage'

    import config from '@/config'

    import Menu from '@/components/small/Menu'
    import ToolsSideMenu from "@/components/small/ToolsSideMenu";
    import URLResult from "@/components/small/URLResult";
    import SearchInput from "@/components/small/SearchInput";

    import { RefreshCwIcon, FileTextIcon, FileMinusIcon, FilePlusIcon } from 'vue-feather-icons'

    import Socket from "@/IOSocket"

    import CustomEvents from '@/CustomEvents'

    export default {
        name: "URLSChecker",
        components:{
            RefreshCwIcon,
            FileMinusIcon,
            FilePlusIcon,
            FileTextIcon,
            SearchInput,
            URLResult,
            ToolsSideMenu,
            Menu,
            CustomEvents
        },
        data: function (){
            return {
                filterMode: Storages.localStorage.isSet('URLSChecker:filter_mode')?Storages.localStorage.get('URLSChecker:filter_mode'):'all',
                working: 0,
                text: Storages.localStorage.isSet('URLSChecker:text')?Storages.localStorage.get('URLSChecker:text'):'',
                uas: [],
                selected_ua: Storages.localStorage.isSet('URLSChecker:selected_ua')?Storages.localStorage.get('URLSChecker:selected_ua'):'',
                results: [],
                search_string: '',
                lines: Storages.localStorage.isSet('URLSChecker:text')?Storages.localStorage.get('URLSChecker:text').split('\n').length:0,
                table:{
                    reverse: Storages.localStorage.isSet('URLSChecker:reverse')?Storages.localStorage.get('URLSChecker:reverse'):1,
                    sort_key: Storages.localStorage.isSet('URLSChecker:sort_key')?Storages.localStorage.get('URLSChecker:sort_key'):'URL',
                    columns: {
                        'URL' : ['URL', 'two'],
                        'reason': ['Reason', 'one cent'],
                        'type': ['Type', 'one cent'],
                        'regex': ['RegEx', 'one cent'],
                        'description': ['Description', 'two'],
                    }
                },
            }
        },
        computed: {
            filteredResults: function () {
                return this.results.filter( (err) => {
                    switch (this.filterMode) {
                        case 'errors':{
                            return Object.keys(err).some( (key) => {return String(err[key]).toLowerCase().indexOf(this.search_string) > -1}) && err.status === 'error'
                        }
                        case 'redirects':{
                            return Object.keys(err).some( (key) => {return String(err[key]).toLowerCase().indexOf(this.search_string) > -1}) && err.status === 'redirected'
                        }
                        case 'lovesus':{
                            return Object.keys(err).some( (key) => {return String(err[key]).toLowerCase().indexOf(this.search_string) > -1}) && (err.loves_us === 'YES' || err.redirects_to_us === 'YES')
                        }
                        default:{
                            return Object.keys(err).some( (key) => {return String(err[key]).toLowerCase().indexOf(this.search_string) > -1})
                        }
                    }
                }).sort( (a, b) => {
                    let a_plus = 0;

                    if (a['loves_us'] === 'YES'){
                        a_plus = a_plus - 40
                    }

                    if (a['redirects_to_us'] === 'YES'){
                        a_plus = a_plus - 20
                    }

                    switch (a['status']) {
                        case 'new':{
                            a = 40;
                        }break;
                        case 'parsing':{
                            a = 30;
                        }break;
                        case 'error':{
                            a = 0;
                        }break;
                        case 'redirected':{
                            a = 10;
                        }break;
                        default:{
                            a = 20;
                        }break;
                    }

                    a = a + a_plus

                    let b_plus = 0;

                    if (b['loves_us'] === 'YES'){
                        b_plus = b_plus - 40
                    }

                    if (b['redirects_to_us'] === 'YES'){
                        b_plus = b_plus - 20
                    }

                    switch (b['status']) {
                        case 'new':{
                            b = 40;
                        }break;
                        case 'parsing':{
                            b = 30;
                        }break;
                        case 'error':{
                            b = 0;
                        }break;
                        case 'redirected':{
                            b = 10;
                        }break;
                        default:{
                            b = 20
                        }break;
                    }

                    b = b + b_plus

                    return (a === b ? 0 : a > b ? 1 : -1);
                });
            }
        },
        watch:{
            filterMode: function (val){
                Storages.localStorage.set('URLSChecker:filter_mode', this.filterMode);
            },
            text: function (val) {
                this.lines = this.text.split('\n').length;
                Storages.localStorage.set('URLSChecker:text', this.text);
            },
            selected_ua: function (val) {
                Storages.localStorage.set('URLSChecker:selected_ua', this.selected_ua);
                console.log("-------------------------------------------------------")
            }
        },
        created: function () {
            Socket.$on("message", this.wsReceived);
            CustomEvents.$on("result-restart", this.customEventsHandler);
        },
        beforeDestroy(){
            Socket.$off("message", this.wsReceived)
            CustomEvents.$off("result-restart", this.customEventsHandler);
        },
        mounted: function(){
            this.getUAs();
        },
        methods: {
            customEventsHandler: function (msg){
                msg.status = 'new';
                this.restartResult(msg.id);
            },
            wsReceived:function (msg) {
                if (msg.service === 'urlschecker') {
                    switch (msg.action) {
                        case 'new':{
                            console.log("Received message:")
                            console.log(msg);
                            this.getResult(msg.data);
                        }break;
                        case 'deleted':{
                            console.log("Received message:")
                            console.log(msg);
                            this.results.forEach((value, index) => {
                                if (value.id === msg.data){
                                    this.results.splice(index, 1);
                                }
                            });
                        }break;
                        case 'updated':{
                            this.results.forEach((value, index) => {
                                if (value.id === msg.data){
                                    this.getResult(value.id)
                                }
                            });
                        }break;
                    }
                }
            },
            restartResult: function (result_id){
                axios
                    .get(config.api_url + '/?op=urlresults&cmd=restart&id='+result_id)
                    .then(response => {
                        if (response.data) {
                            this.results.forEach((value, index) => {
                                if (value.id == response.data.id){
                                    this.results.splice(index, 1, value);
                                }
                            });
                        }
                    });
            },
            getResult: function(result_id){
                this.working++;

                axios
                    .get(config.api_url + '/?op=urlresults&cmd=get&id='+result_id)
                    .then(response => {
                        if (response.data) {
                            let found = false;

                            this.results.forEach((value, index) => {
                                if (value.id === response.data.id){
                                    found = true;
                                    this.results.splice(index, 1, response.data);
                                }
                            });

                            if (!found) {
                                this.results.push(response.data);
                            }
                        }
                    })
                    .catch((err)=>{console.log(err)})
                    .finally(() => {this.working--;});
            },
            addNew: function (){
                this.working++;

                let payload = {items: this.text.split('\n').filter((item) => { return item.trim() !== '';})};

                let request_url = config.api_url + '/?op=urlresults&cmd=add';

                axios.post(
                    request_url,
                    qs.stringify(payload),
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    })
                    .then( (response) => {

                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(()=>{
                        this.working--;
                    });
            },
            //TODO:
            saveUA: function (){

            },
            //TODO:
            addAll: function (){

            },
            getResults: function(){
                this.working++;

                axios
                    .get(config.api_url + '/?op=urlresults')
                    .then(response => {
                        if (response.data) {
                            this.results = response.data;
                        }
                    })
                    .catch( (err) => {
                        console.log(err);
                    })
                    .finally(()=>{
                        this.working--;
                    })
            },
            getUAs: function (){
                this.working++;

                axios
                    .get(config.api_url + '/?op=uas')
                    .then(response => {
                        this.uas = response.data;
                        this.getResults();
                    })
                    .finally(()=>{
                        this.working--;
                    })
            },
        }
    }
</script>

<style scoped>
    #content{
        flex-wrap: wrap;
    }

    .side{
        width: unset;
        border-right: none;
        border-bottom: none;
    }

    .textarea-accessory{
        text-align: right;
        margin: 0;
        align-items: center;
        justify-content: flex-end;
        font-family: monospace;
        flex: 1;
    }

    .textarea-accessory button:last-of-type{
        margin-right: 0;
    }

    .textarea-accessory span{
        margin: 0 0.5rem;
        color: #ffffff;
        text-shadow: -1px 1px 0px #4e1b14;
    }

    .page-content > .wrap-form > div{
        margin: 0.25rem;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .page-content{
        height: 100%;
        flex: 4 80%;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0.5rem;
        overflow-y: auto;
        align-content: start;
    }

    .page-content p span{
        text-align: right;
        flex: 1;
    }

    #results{
        width: 100%;
    }
    .lds-ellipsis.small {
        width: 28px;
        height: 28px;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }

    .lds-ellipsis.small div {
        top: 8px;
        border-radius: 50%;
        background: #93291E;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #93291E;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

    .searchbox{
        padding: 0.5rem;
        padding-left: 1.8rem;
        flex: 1 100%;
        display: flex;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
        justify-content: space-between;
    }

    .searchbox input{
        margin: 0.2rem;
        width: 10rem;
    }

    .searchbox svg{
        width: 1.1rem;
        margin: 0.2rem 0.2rem 0.2rem 0.2rem;
    }

    .searchbox{
        text-shadow: 1px 1px 0px #dadada;
    }

    .first{
        flex: 1;
    }

    .filter{
        width: auto;
    }

    .filter span{
        font-weight: bold;
        color: #444;
    }

    .filter span.loves{
        color: #ff028f;
    }

    .filter span.redirects{
        color: #ffaf03;
    }

    .filter span.errors{
        color: #ff052c;
    }
</style>
